/**
 * DO NOT EDIT -- GENERATED AUTOMATICALLY via generate-tokens.ts script. Run `pnpm generate:design-tokens` from the project root to regenerate
 *  */
export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const BREAKPOINTS: Breakpoint[] = ['sm', 'md', 'lg', 'xl', 'xxl'];

export const BASE_UNIT: string = '4px';

export type Space = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export const SPACES: Space[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export type Columns = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const COLUMNS: Columns[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export type TextTone = 'lt' | 'md' | 'button';

export const TEXT_TONES: TextTone[] = ['lt', 'md', 'button'];

export type Color =
  | 'white'
  | 'black'
  | 'background'
  | 'neutral-xlt'
  | 'neutral-lt'
  | 'neutral-md'
  | 'neutral-dk'
  | 'primary-md'
  | 'primary-md-lighten'
  | 'primary-lt'
  | 'primary-md-darken'
  | 'primary-dk'
  | 'secondary-lt'
  | 'secondary-md'
  | 'secondary-dk'
  | 'tertiary-md'
  | 'tertiary-lt'
  | 'tertiary-dk'
  | 'quaternary-md'
  | 'quaternary-lt'
  | 'quaternary-dk'
  | 'success-md'
  | 'success-md-lighten'
  | 'success-lt'
  | 'success-md-darken'
  | 'success-dk'
  | 'danger-md'
  | 'danger-md-lighten'
  | 'danger-lt'
  | 'danger-md-darken'
  | 'danger-dk'
  | 'blackout-dk'
  | 'blackout-lt'
  | 'separator'
  | 'green-lt'
  | 'green-md'
  | 'green-dk'
  | 'shadow'
  | 'rainbow-gradient'
  | 'rainbow-gradient-reverse';

export const COLORS: Color[] = [
  'white',
  'black',
  'background',
  'neutral-xlt',
  'neutral-lt',
  'neutral-md',
  'neutral-dk',
  'primary-md',
  'primary-md-lighten',
  'primary-lt',
  'primary-md-darken',
  'primary-dk',
  'secondary-lt',
  'secondary-md',
  'secondary-dk',
  'tertiary-md',
  'tertiary-lt',
  'tertiary-dk',
  'quaternary-md',
  'quaternary-lt',
  'quaternary-dk',
  'success-md',
  'success-md-lighten',
  'success-lt',
  'success-md-darken',
  'success-dk',
  'danger-md',
  'danger-md-lighten',
  'danger-lt',
  'danger-md-darken',
  'danger-dk',
  'blackout-dk',
  'blackout-lt',
  'separator',
  'green-lt',
  'green-md',
  'green-dk',
  'shadow',
  'rainbow-gradient',
  'rainbow-gradient-reverse',
];
